export const DEPLOYMENT_PRODUCTION = 'production'
export const DEPLOYMENT_DEVELOPMENT = 'development'
export const ADMIN_EMAIL = 'general@justlockit.com'
export const PRODUCTION_HOSTNAME = 'justlockit.com'
export const DEVELOPMENT_HOSTNAME = 'justlockit-dev.com'

type DeploymentEnv =
  | typeof DEPLOYMENT_PRODUCTION
  | typeof DEPLOYMENT_DEVELOPMENT

export const normalizeDeploymentHostname = (
  hostname = window.location.hostname
) =>
  hostname
    .trim()
    .toLowerCase()
    .replace(/^www\./, '')

export const isProductionDeployment = (hostname = window.location.hostname) =>
  normalizeDeploymentHostname(hostname) === PRODUCTION_HOSTNAME

export const isDevelopmentDeployment = (hostname = window.location.hostname) =>
  normalizeDeploymentHostname(hostname) === DEVELOPMENT_HOSTNAME

export const getDeploymentEnvFromHostname = (
  hostname = window.location.hostname
): DeploymentEnv | undefined => {
  if (isProductionDeployment(hostname)) {
    return DEPLOYMENT_PRODUCTION
  }

  if (isDevelopmentDeployment(hostname)) {
    return DEPLOYMENT_DEVELOPMENT
  }

  return undefined
}

export const isDevelopmentEnvironment = ({
  deploymentEnv,
  hostname,
}: {
  deploymentEnv?: string | null
  hostname?: string
} = {}) =>
  resolveDeploymentEnv({ deploymentEnv, hostname }) === DEPLOYMENT_DEVELOPMENT

export const normalizeDeploymentEnv = (
  deploymentEnv?: string | null
): DeploymentEnv | undefined => {
  const normalized = deploymentEnv?.trim().toLowerCase()

  if (normalized === 'production' || normalized === 'prod') {
    return DEPLOYMENT_PRODUCTION
  }

  if (normalized === 'development' || normalized === 'dev') {
    return DEPLOYMENT_DEVELOPMENT
  }

  return undefined
}

export const resolveDeploymentEnv = ({
  deploymentEnv = (
    globalThis as typeof globalThis & {
      __DEPLOYMENT_ENV__?: string
    }
  ).__DEPLOYMENT_ENV__,
  hostname = window.location.hostname,
}: {
  deploymentEnv?: string | null
  hostname?: string
} = {}): DeploymentEnv => {
  const hostnameDeploymentEnv = getDeploymentEnvFromHostname(hostname)

  if (hostnameDeploymentEnv != null) {
    return hostnameDeploymentEnv
  }

  const normalizedDeploymentEnv = normalizeDeploymentEnv(deploymentEnv)

  if (normalizedDeploymentEnv != null) {
    return normalizedDeploymentEnv
  }

  return DEPLOYMENT_DEVELOPMENT
}

const getOptionalViteEnv = (value?: string) => value?.trim() ?? ''

export const getEnvVariables = ({
  deploymentEnv,
  hostname,
}: {
  deploymentEnv?: string | null
  hostname?: string
} = {}) => {
  const resolvedDeploymentEnv = resolveDeploymentEnv({
    deploymentEnv,
    hostname,
  })
  const mapsEnv = {
    MAP_KEY: getOptionalViteEnv(import.meta.env.VITE_MAP_KEY),
    PLACE_ID: getOptionalViteEnv(import.meta.env.VITE_PLACE_ID),
  }

  if (resolvedDeploymentEnv === DEPLOYMENT_PRODUCTION) {
    return {
      FIREBASE_API_KEY: 'AIzaSyAmsuPkmrVwrUn4lOT5vUECy_6zxpuTM0g',
      FIREBASE_AUTH_DOMAIN: 'justlockit-fdfe7.firebaseapp.com',
      FIREBASE_DATABASE_URL: 'https://justlockit-fdfe7.firebaseio.com',
      FIREBASE_PROJECT_ID: 'justlockit-fdfe7',
      FIREBASE_STORAGE_BUCKET: 'justlockit-fdfe7.firebasestorage.app',
      FIREBASE_MESSAGING_SENDER_ID: '467180878635',
      FIREBASE_APP_ID: '1:467180878635:web:9ef29c88dd16d9f67f636e',
      ADMIN_EMAIL,
      SERVER_URL: 'https://justlockit.herokuapp.com',
      ...mapsEnv,
    }
  }

  return {
    FIREBASE_API_KEY: 'AIzaSyBUKJi8-X3lQAVG9Dk1CXU_Zh__zyZsZ6Q',
    FIREBASE_AUTH_DOMAIN: 'justlockit-dev.firebaseapp.com',
    FIREBASE_DATABASE_URL: 'https://justlockit-dev-default-rtdb.firebaseio.com',
    FIREBASE_PROJECT_ID: 'justlockit-dev',
    FIREBASE_STORAGE_BUCKET: 'justlockit-dev.appspot.com',
    FIREBASE_MESSAGING_SENDER_ID: '406253846105',
    FIREBASE_APP_ID: '1:406253846105:web:f12c1a03e4ca7a9dee7b48',
    ADMIN_EMAIL,
    SERVER_URL: 'https://justlockit-dev.herokuapp.com',
    ...mapsEnv,
  }
}
